import './Title.css'

const Title = ({title_1, title_2}) => {
    return (
        <h1>
            {title_1}<br />{title_2}
        </h1>
    )
}

export default Title;
